import { Platform } from 'react-native';

import { isIOS } from 'utils/environment';

interface IGetMapUrl {
  coordinates: string;
  label?: string;
}

const isMobileWebAndroid = /android/i.test(navigator.userAgent);

const IOS_MAPS_QUERY = 'maps://0,0?q=';
const ANDROID_MAPS_QUERY = 'geo:0,0?q=';
const GOOGLE_MAPS_QUERY = 'https://maps.google.com/?q=';

export const getMapUrl = ({ coordinates, label }: IGetMapUrl): string => {
  let url: string = '';

  if (isIOS()) {
    // open maps app for both ios and mobile iOS
    url = `${IOS_MAPS_QUERY}${label}@${coordinates}`;
  } else if (Platform.OS === 'android' || isMobileWebAndroid) {
    // open google maps app for both android and mobile android
    url = `${ANDROID_MAPS_QUERY}${coordinates}(${label})`;
  } else {
    // open new browser tab with google map location
    url = `${GOOGLE_MAPS_QUERY}${coordinates}`;
  }

  return url;
};
